var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card modal-card--md" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm.modalScreenShowing !== "new"
          ? _c("span", [_vm._v("Select Bucketing")])
          : _vm._e(),
        _vm.modalScreenShowing === "new"
          ? _c("span", [_vm._v("Custom Bucketing")])
          : _vm._e(),
      ]),
      _c(
        "a",
        {
          staticClass: "close-modal",
          attrs: { "aria-label": "close" },
          on: {
            click: function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _c("section", { staticClass: "modal-card-body" }, [
      _vm.modalScreenShowing !== "new"
        ? _c("div", [
            _c("p", [
              _vm._v(
                " Select the bucketing approach you'd like for your query. "
              ),
            ]),
            _c("h5", [_vm._v(" Regulatory ")]),
            _vm.optionsData && _vm.optionsData.default_bucketing_sets
              ? _c(
                  "div",
                  _vm._l(
                    _vm.optionsData.default_bucketing_sets,
                    function (bucket, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "pseudo-selector",
                          class: {
                            "pseudo-selector--active":
                              _vm.typeOfBucketSelected === "regulatory" &&
                              _vm.internalSelectedBucketing === index,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectBucket("regulatory", index)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "pseudo-selector__radio" }),
                          _vm._v(
                            " Regulatory Bucketing Approach " +
                              _vm._s(index) +
                              " "
                          ),
                          _c("div", { staticClass: "bucket-detail" }, [
                            _vm._v(" " + _vm._s(bucket) + " "),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _c("h5", [_vm._v(" Custom ")]),
            _vm.customBuckets && _vm.customBuckets.length
              ? _c("div", { staticClass: "historial-buckets" }, [
                  _c(
                    "div",
                    { staticClass: "historical-bucket-container" },
                    _vm._l(_vm.customBuckets, function (histBucket, index) {
                      return _c(
                        "div",
                        {
                          key: "hb_" + index,
                          staticClass: "pseudo-selector",
                          class: {
                            "pseudo-selector--active":
                              _vm.typeOfBucketSelected === "custom" &&
                              _vm.internalCustomSelectedBucketing ===
                                histBucket.id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectBucket("custom", histBucket.id)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "pseudo-selector__radio" }),
                          _vm._v(" " + _vm._s(histBucket.name) + " "),
                          _c(
                            "div",
                            { staticClass: "bucket-values bucket-detail" },
                            [_vm._v(" " + _vm._s(histBucket.value) + " ")]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.modalScreenShowing === "new"
        ? _c("div", [
            _c("p", [
              _vm._v(
                " Create a new custom bucket, or select one you have used previously. "
              ),
            ]),
            _c(
              "div",
              { staticClass: "pseudo-selector pseudo-selector--no-checkbox" },
              [_vm._v(" New Custom Bucketing Approach ")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customBucketName,
                  expression: "customBucketName",
                },
              ],
              staticClass: "input",
              attrs: {
                type: "text",
                placeholder: "Name your custom bucketing approach",
              },
              domProps: { value: _vm.customBucketName },
              on: {
                focus: function ($event) {
                  return _vm.newCustomBucketInputFocuessed()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.customBucketName = $event.target.value
                },
              },
            }),
            _c("h6", [_vm._v(" Thresholds (in years) ")]),
            _c(
              "div",
              { staticClass: "custom-inputs-row" },
              [
                _vm._l(_vm.bucketDividers.length, function (n) {
                  return _c(
                    "div",
                    { key: "bd_" + n, staticClass: "input-container" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bucketDividers[n - 1],
                            expression: "bucketDividers[n - 1]",
                          },
                        ],
                        staticClass: "input",
                        attrs: { type: "text", placeholder: "0" },
                        domProps: { value: _vm.bucketDividers[n - 1] },
                        on: {
                          focus: function ($event) {
                            return _vm.newCustomBucketInputFocuessed()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.bucketDividers,
                              n - 1,
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "delete-divider",
                          on: {
                            click: function ($event) {
                              return _vm.removeDividerAtIndex(n - 1)
                            },
                          },
                        },
                        [_vm._v(" × ")]
                      ),
                    ]
                  )
                }),
                _c(
                  "button",
                  {
                    staticClass: "button button-primary button-icon",
                    attrs: {
                      disabled: _vm.bucketDividers.length >= _vm.MAX_DIVIDERS,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addBucketDivider()
                      },
                    },
                  },
                  [_c("i", { staticClass: "material-icons" }, [_vm._v("add")])]
                ),
              ],
              2
            ),
            _c("div", { staticClass: "error-text custom-inputs-error" }, [
              _vm._v(" " + _vm._s(_vm.bucketDividersError) + " "),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "buttons-row",
          class: {
            "buttons-row--space-between": _vm.modalScreenShowing !== "new",
          },
        },
        [
          _vm.modalScreenShowing !== "new"
            ? _c(
                "button",
                {
                  staticClass:
                    "button button-secondary button-outline button-medium",
                  on: {
                    click: function ($event) {
                      return _vm.toggleCustomBucketingView()
                    },
                  },
                },
                [_vm._v(" Create Custom Bucket ")]
              )
            : _vm._e(),
          _c("div", [
            _vm.modalScreenShowing !== "new"
              ? _c(
                  "button",
                  {
                    staticClass:
                      "button button-secondary button-outline button-medium",
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [_vm._v(" Cancel ")]
                )
              : _vm._e(),
            _vm.modalScreenShowing === "new"
              ? _c(
                  "button",
                  {
                    staticClass:
                      "button button-secondary button-outline button-medium",
                    on: {
                      click: function ($event) {
                        return _vm.toggleCustomBucketingView()
                      },
                    },
                  },
                  [_vm._v(" Back ")]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "button button-primary button-medium",
                attrs: { disabled: _vm.isSavedDisabled },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v(" Save ")]
            ),
          ]),
        ]
      ),
      _vm.customBucketNameError && _vm.modalScreenShowing === "new"
        ? _c("div", { staticClass: "error-text" }, [
            _vm._v(" " + _vm._s(_vm.customBucketNameError) + " "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }